import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import ExportButtons from "@/components/reports/ExportButtons";
import ClientsCard from "@/components/reports/ClientsCard";

/** Reporte de Clientes: nuevos vs recurrentes en el periodo, e inactivos
 * (sin turnos hace mas de N días, configurable). */
export default function ClientsTab({ period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inactiveDays, setInactiveDays] = useState(60);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/clients", { params: { ...periodParams(period), inactive_days: inactiveDays } })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar Clientes", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period, inactiveDays]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || !data) return <p className="text-center text-muted-foreground py-12">Cargando clientes...</p>;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Label className="text-sm text-muted-foreground">Inactivo si no viene hace mas de</Label>
          <Input
            type="number" min={1} value={inactiveDays} className="w-20"
            onChange={(e) => setInactiveDays(Number(e.target.value) || 1)}
            data-testid={REPORTS.clientsInactiveDaysInput}
          />
          <span className="text-sm text-muted-foreground">días</span>
        </div>
        <ExportButtons reportKey="clients" period={period} />
      </div>

      <ClientsCard newCount={data.new_count} returningCount={data.returning_count} />

      <div className="bg-white border border-border rounded-xl p-5" data-testid={REPORTS.clientsInactiveList}>
        <h3 className="text-sm font-medium text-foreground mb-3">Clientes inactivos ({data.inactive_count})</h3>
        {data.inactive_list.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center">No hay clientes inactivos con este criterio.</p>
        ) : (
          <div className="space-y-2">
            {data.inactive_list.map((c) => (
              <div key={c.id} className="flex items-center justify-between text-sm py-1.5 border-b border-border/60 last:border-0">
                <span className="text-foreground">{c.name} <span className="text-muted-foreground">&middot; {c.phone || c.email || "Sin contacto"}</span></span>
                <span className="text-muted-foreground text-xs">Último turno: {c.last_appointment}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
